import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PerfilesRiesgosScore } from '../_models/perfiles-riesgos-score';

@Injectable({
  providedIn: 'root'
})
export class PerfilesRiesgosScoreService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/perfilesRiesgosScore';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map( resp => resp as PerfilesRiesgosScore[]));
  }

  listadoHabilitado() {
    return this.httClient.get(`${this.rutServicio}/enabled`).pipe(map( resp => resp as PerfilesRiesgosScore[]));
  }

  obtenerPorId(idPerfilRiesgoScore: string) {
    return this.httClient.get(`${this.rutServicio}/${idPerfilRiesgoScore}`).pipe(map( resp => resp as PerfilesRiesgosScore));
  }

  obtenerPorPerfilRiesgo(idPerfilRiesgo: string) {
    return this.httClient.get(`${this.rutServicio}/perfilesRiesgos/${idPerfilRiesgo}/enabled`).pipe(map( resp => resp as PerfilesRiesgosScore[]));
  }

  obtenerPorTipoScore(idTipoScore: string) {
    return this.httClient.get(`${this.rutServicio}/listasTiposScore/${idTipoScore}/enabled`).pipe(map( resp => resp as PerfilesRiesgosScore[]));
  }

  guardar(data: PerfilesRiesgosScore) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, data).pipe(map( resp => resp as PerfilesRiesgosScore));
  }

  actualizar(data: PerfilesRiesgosScore) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, data).pipe(map( resp => resp as PerfilesRiesgosScore));
  }

  verificarRango(desde: number, hasta: number, idPerfilRiesgoScore: string) {
    const url = idPerfilRiesgoScore ? `/desde/${desde}/hasta/${hasta}/perfilRiesgoScore/${idPerfilRiesgoScore}/enabled`
      : `/desde/${desde}/hasta/${hasta}/enabled`;
    return this.httClient.get(`${this.rutServicio}${url}`).pipe(map( resp => resp as any));
  }

  verificarValor(valor: number) {
    return this.httClient.get(`${this.rutServicio}/valor/${valor}/enabled`).pipe(map( resp => resp as any));
  }

  verificarRangoConProveedor(idproveedorScore: string, desde: number, hasta: number, idPerfilRiesgoScore: string) {
    const url = idPerfilRiesgoScore ? `/desde/${desde}/hasta/${hasta}/perfilRiesgoScore/${idPerfilRiesgoScore}/proveedorScore/${idproveedorScore}/enabled`
      : `/desde/${desde}/hasta/${hasta}/proveedorScore/${idproveedorScore}/enabled`;
    return this.httClient.get(`${this.rutServicio}${url}`).pipe(map( resp => resp as any));
  }

  verificarValorConProveedor(idproveedorScore: string, valor: number) {
    return this.httClient.get(`${this.rutServicio}/proveedorScore/${idproveedorScore}/valor/${valor}/enabled`).pipe(map( resp => resp as any));
  }

}
